/**
 * SupportUsTab — V2.9.5 — Social links to grow the brand.
 * Renders inside Account → Support Us tab. Pure presentational.
 */
export default function SupportUsTab() {
  const LINKS = [
    { id: "instagram", label: "Instagram", href: "https://www.instagram.com/institutionalsandbox/",
      icon: "fa-brands fa-instagram",
      gradient: "from-fuchsia-500 to-amber-500" },
    { id: "facebook",  label: "Facebook", href: "https://www.facebook.com/profile.php?id=61589587445222",
      icon: "fa-brands fa-facebook-f",
      gradient: "from-blue-500 to-blue-700" },
    { id: "x",        label: "X (Twitter)", href: "https://x.com/institutionalsb?s=21",
      icon: "fa-brands fa-x-twitter",
      gradient: "from-slate-700 to-slate-900" },
  ];

  return (
    <div className="space-y-4" data-testid="support-us-tab">
      <div className="bg-gradient-to-br from-rose-500/10 to-amber-500/10 border border-rose-500/30 rounded-xl p-4">
        <div className="text-base font-bold text-white mb-1">
          <i className="fa-solid fa-heart mr-2 text-rose-400"/>Support Us
        </div>
        <p className="text-xs text-slate-400">
          Follow Institutional Sandbox on social media — every like, share, and DM helps us keep the lights on
          and the AI tokens topped up.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {LINKS.map(link => (
          <a key={link.id} data-testid={`support-us-${link.id}`} href={link.href} target="_blank" rel="noreferrer"
             className={`group relative overflow-hidden bg-gradient-to-br ${link.gradient} p-[1px] rounded-xl hover:scale-[1.03] transition-transform`}>
            <div className="bg-[#0f131b] rounded-[11px] p-4 flex items-center gap-3">
              <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${link.gradient} flex items-center justify-center text-white text-2xl`}>
                <i className={link.icon}/>
              </div>
              <div className="flex-1">
                <div className="text-sm font-bold text-white">{link.label}</div>
                <div className="text-[10px] text-slate-500 truncate">{link.href.replace(/^https?:\/\//, "").slice(0, 40)}…</div>
              </div>
              <i className="fa-solid fa-arrow-up-right-from-square text-slate-500 group-hover:text-white transition-colors"/>
            </div>
          </a>
        ))}
      </div>

      <div className="text-[10px] text-slate-500 text-center py-2">
        Or <a href="mailto:institutionalsandboxsupport@gmail.com" className="text-blue-400 hover:underline">email support</a> with questions, bug reports, or feature ideas.
      </div>
    </div>
  );
}
